@if (showTopNav) {
  <app-top-navigation-toolbar
    [suppressNavMenu]="false"
    [isSideNavOpen]="isSideNavOpen"
    (toggleSideNav)="sidenav.toggle()"
    [isAlertBannerPresent]="isAlertBannerPresent()"
  ></app-top-navigation-toolbar>
}
<div class="emperor-ui-app-root version">
  RUNNING APP VERSION {{ appVersion }}
</div>
<bp-sdk-root [disableToolbar]="true" enable-lifecycle-events></bp-sdk-root>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    (openedStart)="isSideNavOpen = true"
    (closedStart)="isSideNavOpen = false"
  >
    <app-navigation-menu></app-navigation-menu>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-alert-banner></app-alert-banner>
    <div class="main-content">
      @if (appReady()) {
        <router-outlet></router-outlet>
      } @else {
        <app-loader [isFullScreen]="true"></app-loader>
      }
    </div>

    <!-- No Enrollments Warning Dialog -->
    @if (showEnrollmentsWarningDialog) {
      <app-warning-dialog
        [data]="noEnrollmentsDialogData"
        (closeDialog)="hideEnrollmentsWarning()"
        (callback)="hideEnrollmentsWarning()"
      ></app-warning-dialog>
    }
    <app-in-progress-panel></app-in-progress-panel>
  </mat-sidenav-content>
</mat-sidenav-container>

@if (submissionLinkUploadService.isUploading()) {
  <div
    class="upload-overlay"
    role="status"
    aria-label="Uploading documents, please wait"
  >
    <div class="upload-overlay-card">
      <emperor-spinner [diameter]="60"></emperor-spinner>
      <p class="mat-title-small upload-overlay-title">
        Uploading Your Documents
      </p>
      <p class="mat-body-medium upload-overlay-subtitle">
        Please don't navigate away while your files are being saved.
      </p>
    </div>
  </div>
}

@if (debugDrawerVisible()) {
  <div class="debug-drawer-container">
    <app-debug-drawer></app-debug-drawer>
  </div>
}
